/**
 * プログラムエンティティの名前を定数文字列として取得する
 * @param {Object} obj 名前を取得するオブジェクト
 */
function nameof (obj) {
  return Object.keys(obj)[0]
}

/**
 * 負数判定
 * @param {*} value 判定対象
 */
function isNegativeValue (value) {
  if (!isNumeric(value)) { return false }
  const num = parseFloat(value, 10)
  return (num < 0)
}

/**
 * 数値に変換可能かを判定する
 * @param {*} value 判定対象
 * @see Number.isFiniteは引数を数値に変換しないため、文字列の判定が行えないので本メソッドでは使用しない
 * @description 数値判定を行うためのラッパーメソッド
 */
function isNumeric (value) {
  return window.isFinite(value)
}

export default {
  nameof,
  isNegativeValue,
  isNumeric
}
